export default __webpack_public_path__ + "static/autorizacao-de-uso-de-imagem-menor-a4b4a54424adcd0a740c56e72cbe2c34.pdf";